"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBaseURL = void 0;
const constants_1 = require("../constants");
const sameOriginAllowed = (0, constants_1.isServer)()
    ? false
    : constants_1.ALLOWED_DOMAINS.includes(window.location.hostname);
function getBaseURL(env) {
    if (env === 'TESTING') {
        return constants_1.TEST_ENV_API_URL;
    }
    return sameOriginAllowed ? window.location.origin : constants_1.API_URL;
}
exports.getBaseURL = getBaseURL;
//# sourceMappingURL=index.js.map